import Department from "./department";

// Supporting types for related entities
interface Gender {
    id: string;
    description: string;
}

interface JobTitle {
    id: string;
    code: string;
    description: string;
}

interface OfficeLocation {
    id: string;
    code: string;
    description: string;
    addressId: string;
    address?: {
        street1: string | null;
        street2: string | null;
        city: string | null;
        region: { name: string } | null;
        postalCode: string | null;
        country: { name: string } | null;
    };
}

interface Status {
    id: string;
    description: string;
}

// Raw node shape returned by GET /org-chart
interface OrgChartNode {
    id: string;
    employeeCode: string;
    firstName: string;
    lastName: string;
    commonName: string | null;
    managerId: string | null;
    jobTitle: { description: string } | null;
    department: { description: string } | null;
    employeeType: { name: string } | null;
    manager: {
        firstName: string;
        lastName: string;
        commonName: string | null;
        managerId: string | null;
        employeeStatus: { description: string } | null;
    } | null;
}

type D3OrgChartNode = {
    id: string; // Yes
    name: string; // Yes
    imageUrl?: string; // Yes
    title: string | null; // Yes
    department: string | null; // Yes
    parentId: string; // Yes
    size: string;
    employeeType: string
    // Set when the manager is not on the chart (terminated / inactive): "Ryan Watson (TERMINATED)".
    // The employee is then shown under the manager's manager (or the top of the chart).
    inactiveManager?: string | null
}

export const BOSS_MAN_NAME = "Joe DiPlacito"

interface DocumentFields {
    jobTitles: JobTitle[]
}

export type {
    OrgChartNode,
    D3OrgChartNode,
    Gender,
    JobTitle,
    Department,
    OfficeLocation,
    Status,
    DocumentFields,
};
